import CustomMultiSelect from "../../Utilities/CustomMultiSelect";
import Modal from "../../Utilities/Modal";
import React, {useEffect, useState} from "react";
import ApiRoute from "../../../helper/api";
import {toast} from "react-toastify";
import {DatePicker} from "zaman";
import moment from "jalali-moment";
import {getTimeFromDate} from "../../../helper/general";
import {HasAccessComponent} from "../../../helper/permissions";

export default function EditModel({product , closeModal}){
    const [code, setCode] = useState('')
    const [selectedSendMethod, setSelectedSendMethod] = useState([]);
    const [privateProduct, setPrivateProduct] = useState(false);
    const [passGatewayPrice, setPassGatewayPrice] = useState(product?.metadata?.pass_gateway_price === true || product?.metadata?.pass_gateway_price === "y" ? "y" : "n");
    const [productWeightClass, setProductWeightClass] = useState(product?.metadata?.weight_class ?? "");
    const [autoSyncVirtualStorePrice, setAutoSyncVirtualStorePrice] = useState(product?.metadata?.auto_sync_virtual_store_price === true || product?.metadata?.auto_sync_virtual_store_price === "y" ? "y" : "n");
    const [onSale, setOnSale] = useState({
        start:product?.on_sale?.start?.length < 1 ? null : product?.on_sale?.start,
        start_time_at:product?.on_sale?.start?.length < 1 ? null : moment(product?.on_sale?.start).format('HH:mm:ss'),
        end:product?.on_sale?.end?.length < 1 ? null : product?.on_sale?.end,
        end_time_at:product?.on_sale?.end?.length < 1 ? null : moment(product?.on_sale?.end).format('HH:mm:ss')
    });
    const SendMethods = [
        {value: 'free-shipping', label: 'ارسال رایگان'},
        {value: 'free-shipping-tehran-and-karaj', label: 'ارسال رایگان تهران و کرج'}
    ];




    useEffect(() => {
        console.log(onSale)
        for (let cat of product.categories){
            for (const catElement of SendMethods) {
                if (catElement.value === cat){
                    setSelectedSendMethod(catElement)
                }
            }
        }

    }, []);

    async function updateProductCode() {
        let _code = code;
        if (code.length < 1){
            _code = product.code
        }
        const res = await ApiRoute.product.inventory.updateProductCode.fn(product._id,_code)
        //toast.success("با موفقیت ویرایش شد")
    }

    async function updateProductPrivate(){
        await ApiRoute.product.inventory.updateProductPrivate.fn(product._id,{
            is_private: privateProduct
        })
    }

    async function updatePassGatewayPrice(){
        await ApiRoute.product.inventory.updatePassGatewayPrice.fn(product._id,{
            pass_gateway_price: passGatewayPrice === "y"
        })
    }

    async function updateProductWeightClass(){
        await ApiRoute.product.inventory.updateProductWeightClass.fn(product._id,{
            weight_class: productWeightClass
        })
    }

    async function updateAutoSyncVirtualStorePrice(){
        await ApiRoute.product.inventory.updateAutoSyncVirtualStorePrice.fn(product._id,{
            auto_sync_virtual_store_price: autoSyncVirtualStorePrice === "y"
        })
    }

    async function updateOnSale() {
        await ApiRoute.product.inventory.updateOnSale.fn(product._id,onSale)
    }

    const handleMultiSelectSendMethods = async (selectedSendMethod) => {
        setSelectedSendMethod(selectedSendMethod)

        let arr = []
        for (const sendMethod of selectedSendMethod) {
            arr.push(sendMethod.value)
        }
        setSelectedSendMethod()

        const res = await ApiRoute.product.inventory.updateShipping.fn(product._id, {
            category: arr
        })
    }

    async function releasePrice(){
        if(window.confirm("آیا میخواهید قیمت محصول را آزاد سازی کنید؟")){
            await ApiRoute.product.inventory.releasePrice.fn(product._id)
        }
    }

    return (
        <Modal isOpen={true} onClose={closeModal}
               modalWidth="2xl:w-[80%] h-auto scrollbar-style dir-rtl">
            <div className="page-title z-1 mb-3 text-13"><span className="inline-block bg-white pl-3 z-2 relative">اطلاعات اضافی</span>
            </div>
            <div className="border border-gray-7 rounded-md p-3 text-xs">
                <div className="px-1">{product.title}</div>
                <div className="border my-3 border-gray-7 rounded-md p-3 grid gap-5">
                    <div className="flex justify-between">
                        <div>
                            <span className="text-gray-12 ml-1">برند کالا:</span>
                            <span className="text-gray-5">{product?.brand}</span>
                        </div>
                        <div>
                            <span className="text-gray-12 ml-1">رنگ:</span>
                            <span className="text-gray-5">{product.color}</span>
                        </div>
                    </div>

                    {product?.metadata?.reference_extra_percent > 0 &&<div>
                        <button onClick={releasePrice} className="bg-purple-1 text-white px-3 py-2 rounded">آزاد سازی قیمت</button>
                    </div>}

                    <div>
                        <div className="text-gray-12 mb2">محصول خصوصی:</div>
                        <div
                            className="flex items-center justify-between border border-gray-7 bg-gray-1 rounded-md">
                            <select defaultValue={product.status === "private" ? "y" : "n"} onChange={ (e) => setPrivateProduct(e.target.value) } className="flex flex-auto rounded-r-md px-2 bg-none">
                                <option selected={product.status === "private" ? true : false} value="n">خیر</option>
                                <option selected={product.status === "private" ? false : true} value="y">بله</option>
                            </select>
                            <button onClick={updateProductPrivate} className="bg-purple-1 text-white px-3 py-2 rounded-l-md">بروزرسانی</button>
                        </div>
                    </div>

                    <div>
                        <div className="text-gray-12 mb2">غیرفعال کردن قابلیت چندقیمتی:</div>
                        <div
                            className="flex items-center justify-between border border-gray-7 bg-gray-1 rounded-md">
                            <select value={passGatewayPrice} onChange={(e) => setPassGatewayPrice(e.target.value)} className="flex flex-auto rounded-r-md px-2 bg-none">
                                <option value="n">خیر</option>
                                <option value="y">بله</option>
                            </select>
                            <button onClick={updatePassGatewayPrice} className="bg-purple-1 text-white px-3 py-2 rounded-l-md">بروزرسانی</button>
                        </div>
                    </div>

                    <div>
                        <div className="text-gray-12 mb2">رده وزنی محصول:</div>
                        <div
                            className="flex items-center justify-between border border-gray-7 bg-gray-1 rounded-md">
                            <select value={productWeightClass} onChange={(e) => setProductWeightClass(e.target.value)} className="flex flex-auto rounded-r-md px-2 bg-none">
                                <option value="">ندارد</option>
                                <option value="small">کوچک</option>
                                <option value="medium">متوسط</option>
                                <option value="large">بزرگ</option>
                            </select>
                            <button onClick={updateProductWeightClass} className="bg-purple-1 text-white px-3 py-2 rounded-l-md">بروزرسانی</button>
                        </div>
                    </div>

                    <div>
                        <div className="text-gray-12 mb2">یکسان سازی خودکار قیمت فروشگاه مجازی:</div>
                        <div
                            className="flex items-center justify-between border border-gray-7 bg-gray-1 rounded-md">
                            <select value={autoSyncVirtualStorePrice} onChange={(e) => setAutoSyncVirtualStorePrice(e.target.value)} className="flex flex-auto rounded-r-md px-2 bg-none">
                                <option value="n">خیر</option>
                                <option value="y">بله</option>
                            </select>
                            <button onClick={updateAutoSyncVirtualStorePrice} className="bg-purple-1 text-white px-3 py-2 rounded-l-md">بروزرسانی</button>
                        </div>
                    </div>

                    <div>
                        <div className="text-gray-12 mb2">ویرایش شناسه:</div>
                        <div
                            className="flex items-center justify-between border border-gray-7 bg-gray-1 rounded-md">
                            <input defaultValue={product.product_id} onKeyUp={ (e) => setCode(e.target.value) } className="flex flex-auto rounded-r-md px-2 bg-none" type="text"
                                   placeholder="شناسه کالا را وارد کنید"/>
                            <HasAccessComponent permission={`licence_id inventory`} children={<button onClick={updateProductCode} className="bg-purple-1 text-white px-3 py-2 rounded-l-md">بروزرسانی</button>}/>
                        </div>
                    </div>

                    <HasAccessComponent permission={`free_shipment inventory`} children={<div>
                        <div className="text-gray-12 mb-2">ارسال رایگان</div>
                        <div className="CustomMultiSelectStyle2">
                            <CustomMultiSelect
                                options={SendMethods}
                                values={selectedSendMethod}
                                onChange={handleMultiSelectSendMethods}
                                placeholder="دسته های موردنظر را انتخاب کنید..."
                            />
                        </div>
                    </div>}/>

                </div>


                <div className={`bordered-input-7`}>

                    <HasAccessComponent permission={`sale_date inventory`} children={
                        <div className="flex justify-between">
                            <div>
                                <span className="text-gray-12 ml-1">تاریخ شروع:</span>
                                <div className="text-gray-5 gap-2 flex items-center">
                                    <div className={`input-x`}>
                                        <DatePicker
                                            className={`z-[150]`}
                                            defaultValue={onSale.start ?? undefined}
                                            onChange={(e) => {
                                                onSale.start = moment(e.value).format('YYYY-MM-DD');
                                            }}
                                        />
                                    </div>
                                    <input type={`time`} className={`input-x`} defaultValue={getTimeFromDate(onSale.start)} onChange={ e => {
                                        onSale.start_time_at = e.target.value;
                                    } }/>
                                </div>
                            </div>
                            <div>
                                <span className="text-gray-12 ml-1">تاریخ پایان:</span>
                                <div className="text-gray-5 gap-2 flex items-center">
                                    <div className={`input-x`}>
                                        <DatePicker
                                            className={`z-[150]`}
                                            defaultValue={onSale.end ?? undefined}
                                            onChange={(e) => {
                                                onSale.end = moment(e.value).format('YYYY-MM-DD');
                                            }}
                                        />
                                    </div>
                                    <input type={`time`} className={`input-x`} defaultValue={getTimeFromDate(onSale.end)} onChange={ e => {
                                        onSale.end_time_at = e.target.value;
                                    } }/>
                                </div>
                            </div>
                        </div>
                    }/>

                    <button onClick={updateOnSale} className={`btn-green py-1 px-3 rounded`}>ذخیره سازی</button>

                </div>

            </div>
        </Modal>
    )
}